import dayjs from "dayjs";
import { NotificationInstance } from "antd/es/notification/interface";
import { TFunction } from "i18next";
import { UseFormSetError } from "react-hook-form";

import { translateMediaCode } from "@/shared/media";

export const convertToFormData = (
  obj: Record<string, any>,
  formData = new FormData(),
  parentKey = "",
) => {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    const newKey = parentKey ? `${parentKey}${key}` : key;

    if (dayjs.isDayjs(value)) {
      formData.append(newKey, value.toISOString());
    } else if (value instanceof File) {
      formData.append(newKey, value);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        const nestedKey = `${newKey}[${index}]`;
        if (typeof item === "object" && !Array.isArray(item)) {
          convertToFormData(item, formData, nestedKey);
        } else {
          formData.append(nestedKey, item);
        }
      });
    } else if (typeof value === "object" && value != null) {
      convertToFormData(value, formData, `${newKey}.`);
    } else if (![undefined, null].includes(value)) {
      formData.append(newKey, value);
    }
  });
  return formData;
};

export const handleErrors = (
  errors: Record<string, any>,
  setError: UseFormSetError<any>,
  notificationsApi: NotificationInstance,
  t?: TFunction,
) => {
  if (errors?.data && errors.data?.errors) {
    errors.data.errors.forEach((i: any) => {
      const translated = t ? translateMediaCode(i.code, t) : null;
      const message = translated ?? i.detail;
      if (i.attr && setError) {
        setError(i.attr, { type: "custom", message });
      } else {
        notificationsApi.error({ message });
      }
    });
  }
};
